export const generateParentServices = (map) => (request) => {
  const { parentServiceId, parentService } = request;
  const id = parentServiceId || 0;

  const entity = map.get(id) || {
    name: parentService || 'Не указано',
    amount: 0,
    id,
  };

  entity.amount += 1;

  map.set(id, entity);
};
